module.exports = __webpack_public_path__ + "img/D201610_2.52dcf1f4.jpg";